var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Grid, Col } from "./grid";
import React from 'react';
import { styled } from "../utils";
var StyledGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n\n  && {\n    padding: 0;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n\n  && {\n    padding: 0;\n  }\n"])));
var WizardGrid = function (_a) {
    var children = _a.children;
    return (React.createElement(StyledGrid, { "data-component": "WizardGrid" },
        React.createElement(Col, { width: [1, 10 / 12, 8 / 12], px: [0, 1], pt: [0, 4] }, children)));
};
export default WizardGrid;
var templateObject_1;
//# sourceMappingURL=WizardGrid.js.map